/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateResponseBody
 */
export interface CreateResponseBody {
    /**
     * UUID
     * @type {string}
     * @memberof CreateResponseBody
     */
    uuid: string;
}

/**
 * Check if a given object implements the CreateResponseBody interface.
 */
export function instanceOfCreateResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uuid" in value;

    return isInstance;
}

export function CreateResponseBodyFromJSON(json: any): CreateResponseBody {
    return CreateResponseBodyFromJSONTyped(json, false);
}

export function CreateResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
    };
}

export function CreateResponseBodyToJSON(value?: CreateResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
    };
}

